export default __webpack_public_path__ + "static/media/message_case_access.c996f459.png";